import React from 'react';
import SideMenu from '../Components/Layout/SideMenu';
import TopBar from '../Components/Layout/TopBar';
import UsersPageTable from '../Components/Common/UsersPageTable';
import UserPageHeader from '../Components/Common/UserPageHeader';

const Users = () => {
    return ( <main>
        <SideMenu />

        <div className='DashMain'>
            <TopBar PageTitle="Users"/>

            <div className='DashContent'>
                <UserPageHeader HeaderTitle="Users" HeaderSub="Manage user accounts and roles" PageHeaderStyle="PageHeader" BtnText="+ Add User"/>

                <UsersPageTable />
            </div>

        </div>
    </main> );
}
 
export default Users;